// Generated Module Configuration
const moduleConfig = {
  "moduleConfig": {
    "name": "New Module",
    "description": "",
    "size": "small",
    "theme": "uplynk",
    "endpoints": [
      {
        "root_url": "https://services.uplynk.com",
        "path": "/api2/cloudslicer/jobs/list",
        "method": "GET",
        "category": "Cloud Slicer",
        "parameters": {
          "limit": {
            "type": "integer",
            "examples": 50,
            "required": false,
            "displayName": "limit",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "skip": {
            "type": "integer",
            "examples": 50,
            "required": false,
            "displayName": "skip",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          }
        }
      }
    ],
    "elements": []
  },
  "displayOrder": [
    {
      "endpointIndex": 0,
      "paramName": "args.description"
    },
    {
      "endpointIndex": 0,
      "paramName": "source.url"
    },
    {
      "endpointIndex": 1,
      "paramName": "limit"
    },
    {
      "endpointIndex": 1,
      "paramName": "skip"
    },
    {
      "type": "button",
      "elementId": "button_1741264053649"
    }
  ],
  "customElements": [
    {
      "id": "button_1741264053649",
      "type": "button",
      "label": "Apply",
      "variant": "primary",
      "action": "submit"
    }
  ]
};

export default moduleConfig;